(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bars = document.querySelectorAll('.announcement-bar');
    var inEditor = window.Shopify && window.Shopify.designMode;

    bars.forEach(function (bar) {
      var wrapper = bar.closest('.shopify-section') || bar.parentElement;

      // Honor the sticky toggle (off by default in CSS).
      if (wrapper && bar.getAttribute('data-sticky') === 'true') {
        wrapper.classList.add('is-sticky');
      }

      if (bar.getAttribute('data-dismissible') !== 'true') {
        return;
      }

      var key = 'ace-announcement-dismissed-' + (bar.getAttribute('data-dismiss-key') || 'default');

      if (!inEditor) {
        try {
          if (window.localStorage.getItem(key) === '1') {
            bar.hidden = true;
            return;
          }
        } catch (e) {}
      }

      var btn = bar.querySelector('.announcement-bar__close');
      if (btn) {
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          bar.hidden = true;
          try {
            window.localStorage.setItem(key, '1');
          } catch (e) {}
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-directory"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var links = document.querySelectorAll('.brand-directory__nav-link');
    links.forEach(function(link) {
      link.addEventListener('click', function(e) {
        var target = document.querySelector(link.getAttribute('href'));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-products"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-brand-carousel]').forEach(function(carousel) {
      var track = carousel.querySelector('[data-brand-track]');
      var prev = carousel.querySelector('[data-brand-prev]');
      var next = carousel.querySelector('[data-brand-next]');
      if (!track) return;
      if (prev) prev.addEventListener('click', function() {
        track.scrollBy({ left: -300, behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function() {
        track.scrollBy({ left: 300, behavior: 'smooth' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function() {
    var drawer = document.querySelector('[data-cart-drawer]');
    var overlay = document.querySelector('[data-cart-drawer-overlay]');
    var body = document.querySelector('[data-cart-drawer-body]');
    var footer = document.querySelector('[data-cart-drawer-footer]');
    var emptyState = document.querySelector('[data-cart-drawer-empty]');
    var subtotalEl = document.querySelector('[data-cart-drawer-subtotal]');
    var shippingBar = document.querySelector('[data-cart-drawer-shipping-bar]');
    var upsellsContainer = document.querySelector('[data-cart-drawer-upsells]');
    var currencySymbol = drawer ? drawer.getAttribute('data-currency-symbol') || '$' : '$';
    var lastUpsellProductId = null;
    var promoNotice = document.querySelector('[data-cart-drawer-promo-notice]');

    function drawerAttr(name) {
      return drawer ? drawer.getAttribute(name) || '' : '';
    }

    var strings = {
      adding: drawerAttr('data-adding-text'),
      giftLabel: drawerAttr('data-promo-gift-label'),
      giftNote: drawerAttr('data-promo-gift-note'),
      giftQty: drawerAttr('data-promo-gift-qty'),
      free: drawerAttr('data-promo-free'),
      regularPrice: drawerAttr('data-promo-regular-price'),
      giftUnavailable: drawerAttr('data-promo-unavailable')
    };

    function escapeHtml(value) {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function formatMoney(cents) {
      if (typeof cents !== 'number' || isNaN(cents)) return currencySymbol + '0.00';
      return currencySymbol + (cents / 100).toFixed(2);
    }

    function updateShippingBar(totalCents) {
      if (!shippingBar) return;
      var threshold = parseInt(shippingBar.getAttribute('data-threshold'), 10);
      if (!threshold || threshold <= 0) return;
      var msgEl = shippingBar.querySelector('[data-shipping-bar-msg]');
      var fillEl = shippingBar.querySelector('[data-shipping-bar-fill]');
      var remaining = threshold - totalCents;
      var pct = Math.min(100, Math.round((totalCents / threshold) * 100));
      if (fillEl) fillEl.style.width = pct + '%';
      if (remaining > 0) {
        shippingBar.classList.remove('is-unlocked');
        if (msgEl) {
          var tpl = shippingBar.getAttribute('data-msg-remaining') || '';
          msgEl.textContent = tpl.replace('[amount]', formatMoney(remaining));
        }
      } else {
        shippingBar.classList.add('is-unlocked');
        if (msgEl) msgEl.textContent = shippingBar.getAttribute('data-msg-unlocked') || '';
      }
    }

    /*
      Pin the page while the drawer is open. The scrollbar's width is added as
      padding so the page doesn't shift sideways when it disappears. Restoring
      the position must be instant: the site has smooth scrolling on, which
      otherwise animates the page back down from the top on close.
    */
    var scrollY = 0;
    function lockScroll() {
      scrollY = window.scrollY;
      var scrollbar = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + scrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      if (scrollbar > 0) document.body.style.paddingRight = scrollbar + 'px';
    }

    function unlockScroll() {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.paddingRight = '';
      window.scrollTo({ top: scrollY, left: 0, behavior: 'instant' });
    }

    function open() {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      lockScroll();
    }

    function close() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      unlockScroll();
    }

    function updateCount(count) {
      var badges = document.querySelectorAll('[data-cart-count]');
      for (var i = 0; i < badges.length; i++) {
        badges[i].textContent = count;
        if (count > 0) {
          badges[i].classList.remove('header__cart-count--hidden');
        } else {
          badges[i].classList.add('header__cart-count--hidden');
        }
      }

      var countEl = drawer.querySelector('[data-cart-drawer-count]');
      if (countEl) {
        var tpl = count === 1 ? countEl.getAttribute('data-count-one') : countEl.getAttribute('data-count-other');
        countEl.textContent = (tpl || '').replace('[count]', count);
      }
    }

    function itemPriceHtml(item) {
      if (item.final_line_price < item.original_line_price) {
        var current = item.final_line_price === 0 ? escapeHtml(strings.free) : formatMoney(item.final_line_price);
        return '<p class="cart-drawer__item-price">' + current
          + '<s class="cart-drawer__item-price-original"><span class="visually-hidden">' + escapeHtml(strings.regularPrice) + '</span>'
          + formatMoney(item.original_line_price) + '</s></p>';
      }
      return '<p class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</p>';
    }

    function itemActionsHtml(item) {
      if (isGiftLine(item)) {
        var qtyHtml = item.quantity > 1
          ? '<span>' + escapeHtml(strings.giftQty.replace('[quantity]', item.quantity)) + '</span>'
          : '';
        return '<div class="cart-drawer__item-actions">'
          + '<p class="cart-drawer__gift-note"><span>' + escapeHtml(strings.giftNote) + '</span>' + qtyHtml + '</p>'
          + '</div>';
      }
      return '<div class="cart-drawer__item-actions">'
        + '<div class="cart-drawer__qty-stepper">'
        + '<button type="button" class="cart-drawer__qty-btn" data-cart-drawer-minus="' + item.key + '" aria-label="Decrease quantity">-</button>'
        + '<span class="cart-drawer__qty-value" data-cart-drawer-qty-value="' + item.key + '">' + item.quantity + '</span>'
        + '<button type="button" class="cart-drawer__qty-btn" data-cart-drawer-plus="' + item.key + '" aria-label="Increase quantity">+</button>'
        + '</div>'
        + '<button type="button" class="cart-drawer__remove" data-cart-drawer-remove="' + item.key + '" aria-label="Remove item">'
        + '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/></svg>'
        + '</button>'
        + '</div>';
    }

    function renderItems(cart) {
      currencySymbol = (cart.currency && cart.currency.symbol) ? cart.currency.symbol : currencySymbol;

      if (cart.item_count === 0) {
        body.innerHTML = '<div class="cart-drawer__upsells" data-cart-drawer-upsells></div>';
        upsellsContainer = body.querySelector('[data-cart-drawer-upsells]');
        footer.style.display = 'none';
        emptyState.style.display = '';
        return;
      }

      footer.style.display = '';
      emptyState.style.display = 'none';
      subtotalEl.textContent = formatMoney(cart.total_price);
      updateShippingBar(cart.total_price);

      /* Regular lines first, auto-added free gift lines last */
      var regularItems = [];
      var giftItems = [];
      for (var g = 0; g < cart.items.length; g++) {
        if (isGiftLine(cart.items[g])) {
          giftItems.push(cart.items[g]);
        } else {
          regularItems.push(cart.items[g]);
        }
      }
      var orderedItems = regularItems.concat(giftItems);

      var html = '';
      for (var i = 0; i < orderedItems.length; i++) {
        var item = orderedItems[i];
        var isGift = isGiftLine(item);
        var imageUrl = item.image ? item.image.replace(/(\.\w+)(\?|$)/, '_200x200_crop_center$1$2') : '';
        var variantHtml = '';
        if (item.variant_title && item.variant_title !== 'Default Title') {
          variantHtml = '<p class="cart-drawer__item-variant">' + item.variant_title + '</p>';
        }

        html += '<div class="cart-drawer__item' + (isGift ? ' cart-drawer__item--gift' : '') + '" data-cart-drawer-item="' + item.key + '">'
          + '<a href="' + item.url + '" class="cart-drawer__item-image">'
          + (imageUrl ? '<img src="' + imageUrl + '" alt="' + item.title.replace(/"/g, '&quot;') + '" class="cart-drawer__item-img" loading="lazy">' : '')
          + '</a>'
          + '<div class="cart-drawer__item-info">'
          + (isGift ? '<span class="cart-drawer__gift-label">' + escapeHtml(strings.giftLabel) + '</span>' : '')
          + '<a href="' + item.url + '" class="cart-drawer__item-title">' + item.product_title + '</a>'
          + variantHtml
          + itemPriceHtml(item)
          + itemActionsHtml(item)
          + '</div></div>';
      }

      var savedUpsells = upsellsContainer ? upsellsContainer.innerHTML : '';
      var upsellSource = regularItems.length ? regularItems[0] : cart.items[0];
      var newProductId = upsellSource.product_id;
      body.innerHTML = html + '<div class="cart-drawer__upsells" data-cart-drawer-upsells></div>';
      upsellsContainer = body.querySelector('[data-cart-drawer-upsells]');
      if (savedUpsells && lastUpsellProductId === newProductId) {
        upsellsContainer.innerHTML = savedUpsells;
        initUpsellCarousel(upsellsContainer);
      } else {
        loadUpsells(newProductId);
      }
    }

    function applyRender(cart) {
      if (!cart) return;
      renderItems(cart);
      updateCount(cart.item_count);
    }

    /* ------------------------------------------------------------------
       Free gift promotions (docs/promotions.md)
       Rules come from the data-promo-rules JSON. A Buy X get Y automatic
       discount makes the gift free; this keeps the gift line (tagged with the
       hidden _promo_gift line property) in step with the qualifying items.
       ------------------------------------------------------------------ */
    var PROMO_STATE_TTL = 15 * 60 * 1000;
    var MAX_SYNC_PASSES = 3;

    function readPromoConfig() {
      var fallback = { autoAdd: false, rules: [] };
      var el = document.querySelector('[data-promo-rules]');
      if (!el) return fallback;
      try {
        var parsed = JSON.parse(el.textContent);
        if (!parsed || !Array.isArray(parsed.rules)) return fallback;
        return parsed;
      } catch (e) {
        return fallback;
      }
    }

    function loadPromoSet(kind) {
      try {
        var raw = JSON.parse(window.sessionStorage.getItem('promoGifts:' + kind) || '{}');
        var now = Date.now();
        var fresh = {};
        Object.keys(raw).forEach(function(handle) {
          if (now - raw[handle] < PROMO_STATE_TTL) fresh[handle] = raw[handle];
        });
        return fresh;
      } catch (e) {
        return {};
      }
    }

    var promoConfig = readPromoConfig();
    var promoState = {
      failed: loadPromoSet('failed'),          /* gift could not be added (out of stock) */
      suppressed: loadPromoSet('suppressed')   /* discount is not making the gift free */
    };

    function markPromo(kind, handle) {
      promoState[kind][handle] = Date.now();
      try {
        window.sessionStorage.setItem('promoGifts:' + kind, JSON.stringify(promoState[kind]));
      } catch (e) {}
    }

    function giftHandleOf(item) {
      if (!item || !item.properties || !item.properties._promo_gift) return '';
      return String(item.properties._promo_gift);
    }

    function isGiftLine(item) {
      return !!(promoConfig.autoAdd && giftHandleOf(item));
    }

    function fetchCart() {
      return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function(r) {
          if (!r.ok) throw new Error('Cart fetch failed');
          return r.json();
        });
    }

    function postJson(url, data) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(data),
        credentials: 'same-origin'
      });
    }

    /* Pure: works out which gift lines to add, change or remove. `tried`
       remembers quantities requested earlier in this sync so a gift whose
       stock caps the quantity is marked failed instead of retried. */
    function planGiftSync(cart, tried) {
      var plan = { changes: [], adds: [], unavailable: [] };
      if (!promoConfig.autoAdd || !cart || !cart.items) return plan;

      var giftLines = {};
      var known = {};
      var decreases = [];
      var increases = [];

      cart.items.forEach(function(item) {
        var handle = giftHandleOf(item);
        if (handle) (giftLines[handle] = giftLines[handle] || []).push(item);
      });

      promoConfig.rules.forEach(function(rule) {
        known[rule.handle] = true;

        var bought = 0;
        cart.items.forEach(function(item) {
          if (!giftHandleOf(item) && rule.buy.indexOf(item.variant_id) > -1) bought += item.quantity;
        });
        var want = Math.floor(bought / rule.buyQty) * rule.giftQty;
        if (promoState.suppressed[rule.handle]) want = 0;

        var keep = null;
        (giftLines[rule.handle] || []).forEach(function(item) {
          if (!keep && item.variant_id === rule.gift) {
            keep = item;
          } else {
            decreases.push({ key: item.key, quantity: 0, handle: rule.handle });
          }
        });
        var have = keep ? keep.quantity : 0;

        if (want > have && tried && tried[rule.handle] === want) markPromo('failed', rule.handle);
        if (want > have && (promoState.failed[rule.handle] || !rule.giftAvailable)) {
          if (plan.unavailable.indexOf(rule.giftTitle) === -1) plan.unavailable.push(rule.giftTitle);
          want = have;
        }
        if (want === have) return;
        if (tried && want > have) tried[rule.handle] = want;

        if (keep && want < have) {
          decreases.push({ key: keep.key, quantity: want, handle: rule.handle });
        } else if (keep) {
          increases.push({ key: keep.key, quantity: want, handle: rule.handle });
        } else {
          plan.adds.push({ id: rule.gift, quantity: want, properties: { _promo_gift: rule.handle }, handle: rule.handle });
        }
      });

      /* Gift lines whose promotion was switched off or deleted */
      Object.keys(giftLines).forEach(function(handle) {
        if (known[handle]) return;
        giftLines[handle].forEach(function(item) {
          decreases.push({ key: item.key, quantity: 0, handle: handle });
        });
      });

      plan.changes = decreases.concat(increases);
      return plan;
    }

    function planHasWork(plan) {
      return plan.changes.length > 0 || plan.adds.length > 0;
    }

    /* If a gift line is in the cart but nothing on the gift variant is
       discounted, the discount isn't applying (ended, or the customer isn't
       eligible). Stop auto-adding that gift so nobody pays for a "free" gift. */
    function checkGiftDiscounts(cart) {
      var suppressedNew = false;
      if (!promoConfig.autoAdd || !cart || !cart.items) return false;
      promoConfig.rules.forEach(function(rule) {
        if (promoState.suppressed[rule.handle]) return;
        var hasGiftLine = false;
        var original = 0;
        var discounted = 0;
        cart.items.forEach(function(item) {
          if (item.variant_id !== rule.gift) return;
          if (giftHandleOf(item) === rule.handle) hasGiftLine = true;
          original += item.original_line_price;
          discounted += item.original_line_price - item.final_line_price;
        });
        if (hasGiftLine && original > 0 && discounted <= 0) {
          markPromo('suppressed', rule.handle);
          suppressedNew = true;
        }
      });
      return suppressedNew;
    }

    /* Requests run one at a time: concurrent cart writes can overwrite each other. */
    function runPlan(plan) {
      var steps = [];
      plan.changes.forEach(function(change) {
        steps.push(function() {
          return postJson('/cart/change.js', { id: change.key, quantity: change.quantity })
            .then(function(r) {
              if (!r.ok && r.status === 422 && change.quantity > 0) markPromo('failed', change.handle);
            });
        });
      });
      plan.adds.forEach(function(add) {
        steps.push(function() {
          return postJson('/cart/add.js', { items: [{ id: add.id, quantity: add.quantity, properties: add.properties }] })
            .then(function(r) {
              if (!r.ok) markPromo('failed', add.handle);
            });
        });
      });
      return steps.reduce(function(chain, step) {
        return chain.then(function() {
          return step().catch(function() {});
        });
      }, Promise.resolve());
    }

    function renderPromoNotice(titles) {
      if (!promoNotice) return;
      if (!titles.length) {
        promoNotice.hidden = true;
        promoNotice.textContent = '';
        return;
      }
      promoNotice.textContent = titles.map(function(title) {
        return strings.giftUnavailable.replace('[title]', title);
      }).join(' ');
      promoNotice.hidden = false;
    }

    /* Resolves to { cart, changed } once gift lines match the cart. */
    function syncGifts(cart) {
      if (!promoConfig.autoAdd || !cart || !cart.items) {
        return Promise.resolve({ cart: cart, changed: false });
      }
      var tried = {};
      var changed = false;

      function pass(current, count) {
        checkGiftDiscounts(current);
        var plan = planGiftSync(current, tried);
        renderPromoNotice(plan.unavailable);
        if (!planHasWork(plan) || count > MAX_SYNC_PASSES) {
          return Promise.resolve({ cart: current, changed: changed });
        }
        changed = true;
        return runPlan(plan)
          .then(fetchCart)
          .then(function(next) { return pass(next, count + 1); });
      }

      return pass(cart, 1);
    }

    function needsGiftSync(cart) {
      if (!promoConfig.autoAdd) return false;
      if (checkGiftDiscounts(cart)) return true;
      return planHasWork(planGiftSync(cart, null));
    }

    /* Single-flight: a refresh requested while one is running is queued (not
       dropped) and re-reads the cart, so the last pass always sees the latest
       cart. Quiet refreshes only re-render when gift lines changed. */
    var refreshPromise = null;
    var refreshQueued = false;
    var refreshQueuedQuiet = true;

    function refresh(opts) {
      var quiet = !!(opts && opts.quiet);
      if (refreshPromise) {
        refreshQueued = true;
        if (!quiet) refreshQueuedQuiet = false;
        return refreshPromise;
      }

      refreshPromise = fetchCart()
        .then(syncGifts)
        .then(function(result) {
          if (!quiet || result.changed) applyRender(result.cart);
          return result;
        })
        .catch(function() {
          return { cart: null, changed: false };
        })
        .then(function(result) {
          refreshPromise = null;
          if (!refreshQueued) return result;
          var nextQuiet = refreshQueuedQuiet;
          refreshQueued = false;
          refreshQueuedQuiet = true;
          return refresh({ quiet: nextQuiet }).then(function(next) {
            return { cart: next.cart || result.cart, changed: result.changed || next.changed };
          });
        });

      return refreshPromise;
    }

    /* Skeleton line shown at the top of the drawer while an added item (and
       any free gift) reaches the cart, instead of the stale or empty cart. */
    var SKELETON_ROW = '<div class="cart-drawer__item cart-drawer__item--skeleton" data-cart-drawer-skeleton aria-hidden="true">'
      + '<div class="cart-drawer__item-image"><span class="cart-drawer__skeleton cart-drawer__skeleton--image"></span></div>'
      + '<div class="cart-drawer__item-info">'
      + '<span class="cart-drawer__skeleton cart-drawer__skeleton--title"></span>'
      + '<span class="cart-drawer__skeleton cart-drawer__skeleton--variant"></span>'
      + '<span class="cart-drawer__skeleton cart-drawer__skeleton--price"></span>'
      + '<div class="cart-drawer__item-actions">'
      + '<span class="cart-drawer__skeleton cart-drawer__skeleton--qty"></span>'
      + '<span class="cart-drawer__skeleton cart-drawer__skeleton--remove"></span>'
      + '</div></div></div>';

    function showLoading() {
      if (!body) return;
      drawer.classList.add('is-loading');
      body.setAttribute('aria-busy', 'true');
      if (!body.querySelector('[data-cart-drawer-skeleton]')) body.insertAdjacentHTML('afterbegin', SKELETON_ROW);
      if (emptyState) emptyState.style.display = 'none';
      if (footer) footer.style.display = '';
      if (subtotalEl) subtotalEl.classList.add('is-loading', 'cart-drawer__skeleton');
    }

    function hideLoading() {
      if (!body) return;
      drawer.classList.remove('is-loading');
      body.removeAttribute('aria-busy');
      var rows = body.querySelectorAll('[data-cart-drawer-skeleton]');
      for (var i = 0; i < rows.length; i++) rows[i].remove();
      if (subtotalEl) subtotalEl.classList.remove('is-loading', 'cart-drawer__skeleton');
      /* Nothing rendered (request failed): show the empty state again if the drawer has no lines */
      if (!body.querySelector('[data-cart-drawer-item]')) {
        if (footer) footer.style.display = 'none';
        if (emptyState) emptyState.style.display = '';
      }
    }

    function addItem(formData, submitBtn) {
      if (submitBtn) {
        submitBtn.dataset.originalText = submitBtn.textContent;
        submitBtn.textContent = strings.adding || submitBtn.textContent;
        submitBtn.disabled = true;
        submitBtn.classList.add('is-loading');
      }

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        credentials: 'same-origin'
      })
      .then(function(r) {
        if (!r.ok) throw new Error('Add to cart failed');
        return r.json();
      })
      .then(function() {
        if (submitBtn) {
          submitBtn.textContent = submitBtn.dataset.originalText;
          submitBtn.disabled = false;
          submitBtn.classList.remove('is-loading');
        }
        showLoading();
        open();
        refresh().then(hideLoading, hideLoading);
      })
      .catch(function(err) {
        console.error(err);
        if (submitBtn) {
          submitBtn.textContent = submitBtn.dataset.originalText;
          submitBtn.disabled = false;
          submitBtn.classList.remove('is-loading');
        }
      });
    }

    /* Quantity changes are debounced per line: every line touched during the
       debounce window is sent, one request at a time. */
    var changeTimer = null;
    var pendingChanges = {};
    var changeChain = Promise.resolve();
    var changesInFlight = 0;

    function changeItem(key, quantity) {
      /* Optimistic UI: update quantity display and price immediately */
      var qtyEl = drawer.querySelector('[data-cart-drawer-qty-value="' + key + '"]');
      if (qtyEl) qtyEl.textContent = quantity;

      if (quantity === 0) {
        var itemEl = drawer.querySelector('[data-cart-drawer-item="' + key + '"]');
        if (itemEl) itemEl.style.opacity = '0.4';
      }

      pendingChanges[key] = quantity;
      clearTimeout(changeTimer);
      changeTimer = setTimeout(flushChanges, 300);
    }

    /* After a quantity change: re-render straight from the response, unless the
       gift lines need updating, in which case refresh (which syncs) instead. */
    function applyCart(cart) {
      if (refreshPromise || needsGiftSync(cart)) return refresh();
      applyRender(cart);
      return Promise.resolve({ cart: cart, changed: false });
    }

    function flushChanges() {
      clearTimeout(changeTimer);
      changeTimer = null;
      var keys = Object.keys(pendingChanges);
      if (!keys.length) return changeChain;

      var batch = pendingChanges;
      pendingChanges = {};
      changesInFlight += 1;

      changeChain = changeChain.then(function() {
        var lastCart = null;
        var failed = false;
        return keys.reduce(function(chain, key) {
          return chain.then(function() {
            return postJson('/cart/change.js', { id: key, quantity: batch[key] })
              .then(function(r) {
                if (!r.ok) throw new Error('Cart update failed');
                return r.json();
              })
              .then(function(cart) {
                if (cart && typeof cart.item_count !== 'undefined') lastCart = cart;
              })
              .catch(function() { failed = true; });
          });
        }, Promise.resolve()).then(function() {
          if (failed || !lastCart) return refresh();
          return applyCart(lastCart);
        });
      }).catch(function() {}).then(function() {
        changesInFlight -= 1;
      });

      return changeChain;
    }

    function hasPendingCartWork() {
      return !!(changeTimer || changesInFlight > 0 || refreshPromise);
    }

    function initUpsellCarousel(container) {
      var track = container.querySelector('[data-cart-upsells-track]');
      var prev = container.querySelector('[data-cart-upsells-prev]');
      var next = container.querySelector('[data-cart-upsells-next]');
      if (!track) return;
      var scrollAmount = 200;
      if (prev) prev.addEventListener('click', function() {
        track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function() {
        track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });
      // Grey out each arrow at its end of the row.
      var syncArrows = function() {
        var maxLeft = track.scrollWidth - track.clientWidth;
        if (prev) prev.disabled = track.scrollLeft <= 1;
        if (next) next.disabled = track.scrollLeft >= maxLeft - 1;
      };
      track.addEventListener('scroll', syncArrows, { passive: true });
      syncArrows();
      setTimeout(syncArrows, 400);
    }

    function loadUpsells(productId) {
      if (!upsellsContainer || !productId) return;
      lastUpsellProductId = productId;
      var url = '/recommendations/products?product_id=' + productId + '&limit=6&section_id=cart-upsells';
      fetch(url)
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var temp = document.createElement('div');
          temp.innerHTML = html;
          var content = temp.querySelector('[data-cart-upsells-section]');
          if (content && content.innerHTML.trim() !== '') {
            var style = temp.querySelector('style');
            upsellsContainer.innerHTML = (style ? style.outerHTML : '') + content.innerHTML;
            initUpsellCarousel(upsellsContainer);
          } else {
            upsellsContainer.innerHTML = '';
          }
        })
        .catch(function() {});
    }

    /* --- Event listeners --- */

    // Close drawer
    if (overlay) overlay.addEventListener('click', close);

    drawer.addEventListener('click', function(e) {
      if (e.target.closest('[data-cart-drawer-close]')) {
        close();
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        close();
      }
    });

    // Cart icon toggle
    document.addEventListener('click', function(e) {
      var toggle = e.target.closest('[data-cart-drawer-toggle]');
      if (toggle) {
        e.preventDefault();
        refresh();
        open();
      }
    });

    // Quantity and remove actions (delegated on drawer body)
    drawer.addEventListener('click', function(e) {
      var minusBtn = e.target.closest('[data-cart-drawer-minus]');
      var plusBtn = e.target.closest('[data-cart-drawer-plus]');
      var removeBtn = e.target.closest('[data-cart-drawer-remove]');

      if (minusBtn) {
        var key = minusBtn.getAttribute('data-cart-drawer-minus');
        var qtyEl = drawer.querySelector('[data-cart-drawer-qty-value="' + key + '"]');
        var qty = parseInt(qtyEl.textContent, 10);
        if (qty > 1) {
          changeItem(key, qty - 1);
        } else {
          changeItem(key, 0);
        }
      }

      if (plusBtn) {
        var key = plusBtn.getAttribute('data-cart-drawer-plus');
        var qtyEl = drawer.querySelector('[data-cart-drawer-qty-value="' + key + '"]');
        var qty = parseInt(qtyEl.textContent, 10);
        changeItem(key, qty + 1);
      }

      if (removeBtn) {
        var key = removeBtn.getAttribute('data-cart-drawer-remove');
        changeItem(key, 0);
      }
    });

    // Global form interception for add-to-cart
    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (form.matches('form[action*="/cart/add"]')) {
        e.preventDefault();
        var formData = new FormData(form);
        var submitBtn = form.querySelector('[type="submit"]');
        addItem(formData, submitBtn);
      }
    });

    // Checkout: finish any pending quantity change and gift sync first
    drawer.addEventListener('click', function(e) {
      var checkoutLink = e.target.closest('.cart-drawer__checkout');
      if (!checkoutLink || !hasPendingCartWork()) return;
      e.preventDefault();
      var go = function() { window.location.href = checkoutLink.href; };
      flushChanges().then(function() { return refresh({ quiet: true }); }).then(go, go);
    });

    // Sync gift lines once on page load (catches promotions switched off since
    // the gift was added, and carts changed outside the drawer)
    var initialSync = Promise.resolve({ cart: null, changed: false });
    if (promoConfig.autoAdd && drawerAttr('data-has-items') === 'true') {
      if (promoConfig.rules.length || drawer.hasAttribute('data-has-gift-lines')) {
        initialSync = refresh({ quiet: true });
      }
    }
    initialSync.then(function(result) {
      document.dispatchEvent(new CustomEvent('cart:gifts-synced', {
        detail: { changed: !!(result && result.changed) }
      }));
    });

    // Expose global API
    window.CartDrawer = {
      open: open,
      close: close,
      refresh: refresh,
      addItem: addItem,
      initialSync: initialSync,
      promoActive: !!(promoConfig.autoAdd && (promoConfig.rules.length || drawer.hasAttribute('data-has-gift-lines'))),
      syncGifts: function() {
        return flushChanges().then(function() { return refresh({ quiet: true }); });
      }
    };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-upsells"]) return;
  try {
    
  (function() {
    var section = document.querySelector('[data-cart-upsells-section]');
    if (!section) return;

    var track = section.querySelector('[data-cart-upsells-track]');
    var prev = section.querySelector('[data-cart-upsells-prev]');
    var next = section.querySelector('[data-cart-upsells-next]');
    if (!track) return;

    var scrollAmount = 200;
    if (prev) prev.addEventListener('click', function() {
      track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function() {
      track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
    // Grey out each arrow at its end of the row.
    var syncArrows = function() {
      var maxLeft = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft >= maxLeft - 1;
    };
    track.addEventListener('scroll', syncArrows, { passive: true });
    syncArrows();
    setTimeout(syncArrows, 400);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-cart-minus]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var idx = btn.getAttribute('data-cart-minus');
        var input = document.querySelector('[data-cart-qty="' + idx + '"]');
        var val = parseInt(input.value, 10);
        if (val > 0) input.value = val - 1;
      });
    });

    document.querySelectorAll('[data-cart-plus]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var idx = btn.getAttribute('data-cart-plus');
        var input = document.querySelector('[data-cart-qty="' + idx + '"]');
        input.value = parseInt(input.value, 10) + 1;
      });
    });

    /* Free gift promotions: when the cart drawer's gift sync is active, cart
       updates go through AJAX so the gift line can be re-synced before the
       page reloads or checkout opens. */
    var cartForm = document.querySelector('form.cart-page__layout');
    var RELOAD_GUARD_KEY = 'promoGifts:reloadAt';

    function giftSyncActive() {
      return !!(window.CartDrawer && window.CartDrawer.promoActive && window.CartDrawer.syncGifts);
    }

    function reloadOnce() {
      try {
        var last = parseInt(window.sessionStorage.getItem(RELOAD_GUARD_KEY) || '0', 10);
        if (Date.now() - last < 10000) return;
        window.sessionStorage.setItem(RELOAD_GUARD_KEY, String(Date.now()));
      } catch (e) {
        return;
      }
      window.location.reload();
    }

    if (cartForm) {
      /* Gift lines were added or removed on page load: show the synced cart */
      document.addEventListener('cart:gifts-synced', function(e) {
        if (e.detail && e.detail.changed) reloadOnce();
      });

      cartForm.addEventListener('submit', function(e) {
        if (!giftSyncActive()) return;
        e.preventDefault();
        var submitter = e.submitter;
        var goToCheckout = !!(submitter && submitter.name === 'checkout');

        fetch('/cart/update.js', {
          method: 'POST',
          body: new FormData(cartForm),
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' }
        })
          .then(function(r) {
            if (!r.ok) throw new Error('Cart update failed');
            return window.CartDrawer.syncGifts();
          })
          .then(function() {
            if (goToCheckout) {
              window.location.href = '/checkout';
            } else {
              window.location.reload();
            }
          })
          .catch(function() {
            /* Fall back to the regular form post */
            if (submitter && submitter.name) {
              var hidden = document.createElement('input');
              hidden.type = 'hidden';
              hidden.name = submitter.name;
              hidden.value = submitter.value || '';
              cartForm.appendChild(hidden);
            }
            HTMLFormElement.prototype.submit.call(cartForm);
          });
      });

      cartForm.addEventListener('click', function(e) {
        var removeLink = e.target.closest('[data-cart-remove-key]');
        if (!removeLink || !giftSyncActive()) return;
        e.preventDefault();
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: removeLink.getAttribute('data-cart-remove-key'), quantity: 0 }),
          credentials: 'same-origin'
        })
          .then(function(r) {
            if (!r.ok) throw new Error('Remove failed');
            return window.CartDrawer.syncGifts();
          })
          .then(function() { window.location.reload(); })
          .catch(function() { window.location.href = removeLink.href; });
      });
    }

    var upsellsContainer = document.querySelector('[data-cart-page-upsells]');
    if (upsellsContainer) {
      var productId = upsellsContainer.getAttribute('data-upsells-product-id');
      if (productId) {
        var url = '/recommendations/products?product_id=' + productId + '&limit=6&section_id=cart-upsells';
        fetch(url)
          .then(function(r) { return r.text(); })
          .then(function(html) {
            var temp = document.createElement('div');
            temp.innerHTML = html;
            var content = temp.querySelector('[data-cart-upsells-section]');
            if (content && content.innerHTML.trim() !== '') {
              upsellsContainer.innerHTML = content.outerHTML;
              /* Init carousel arrows after AJAX injection */
              var track = upsellsContainer.querySelector('[data-cart-upsells-track]');
              var prev = upsellsContainer.querySelector('[data-cart-upsells-prev]');
              var next = upsellsContainer.querySelector('[data-cart-upsells-next]');
              if (track) {
                var scrollAmount = 200;
                if (prev) prev.addEventListener('click', function() {
                  track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
                });
                if (next) next.addEventListener('click', function() {
                  track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
                });
                // Grey out each arrow at its end of the row.
                var syncArrows = function() {
                  var maxLeft = track.scrollWidth - track.clientWidth;
                  if (prev) prev.disabled = track.scrollLeft <= 1;
                  if (next) next.disabled = track.scrollLeft >= maxLeft - 1;
                };
                track.addEventListener('scroll', syncArrows, { passive: true });
                syncArrows();
                setTimeout(syncArrows, 400);
              }
            }
          })
          .catch(function() {});
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function() {
    /* Sort */
    var sortSelect = document.querySelector('[data-sort-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function() {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.value);
        window.location.href = url.toString();
      });
    }

    /* Filter toggles */
    document.querySelectorAll('[data-filter-toggle]').forEach(function(toggle) {
      toggle.addEventListener('click', function() {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!expanded));
        var content = toggle.nextElementSibling;
        if (content) content.hidden = expanded;
      });
    });

    /* Filter apply */
    var form = document.querySelector('[data-filters-form]');
    var pendingFilterChange = false;

    function buildFilterUrl() {
      if (!form) return null;
      var formData = new FormData(form);
      var url = new URL(window.location.href);
      var keysToRemove = [];
      url.searchParams.forEach(function(value, key) {
        if (key.startsWith('filter.')) keysToRemove.push(key);
      });
      keysToRemove.forEach(function(key) { url.searchParams.delete(key); });
      url.searchParams.delete('page');
      for (var pair of formData.entries()) {
        if (pair[1] !== '' && pair[1] !== undefined) {
          url.searchParams.append(pair[0], pair[1]);
        }
      }
      return url.toString();
    }

    function refreshMainResults(doc) {
      var oldMain = document.querySelector('.collection-page__main');
      var newMain = doc.querySelector('.collection-page__main');
      if (!oldMain || !newMain) return;
      var oldLines = oldMain.querySelector('.collection-page__lines');
      Array.from(oldMain.children).forEach(function(child) {
        if (child !== oldLines) child.remove();
      });
      Array.from(newMain.children).forEach(function(child) {
        if (!child.classList.contains('collection-page__lines')) {
          oldMain.appendChild(child);
        }
      });
    }

    function refreshToolbarCount(doc) {
      var oldCount = document.querySelector('.collection-page__count');
      var newCount = doc.querySelector('.collection-page__count');
      if (oldCount && newCount) oldCount.textContent = newCount.textContent;
    }

    function refreshFilterBadge(doc) {
      var oldBadge = document.querySelector('.collection-page__filter-badge');
      var newBadge = doc.querySelector('.collection-page__filter-badge');
      var openBtn = document.querySelector('[data-filters-open]');
      if (newBadge && oldBadge) {
        oldBadge.textContent = newBadge.textContent;
      } else if (newBadge && !oldBadge && openBtn) {
        openBtn.appendChild(newBadge.cloneNode(true));
      } else if (!newBadge && oldBadge) {
        oldBadge.remove();
      }
    }

    function refreshSidebarHeader(doc) {
      var oldHeader = document.querySelector('.collection-page__sidebar-header');
      var newHeader = doc.querySelector('.collection-page__sidebar-header');
      if (oldHeader && newHeader) oldHeader.innerHTML = newHeader.innerHTML;
    }

    function refreshFilterCounts(doc) {
      document.querySelectorAll('[data-filter-input]').forEach(function(oldInput) {
        if (oldInput.type !== 'checkbox') return;
        var selector = '[data-filter-input][type="checkbox"][name="' + CSS.escape(oldInput.name) + '"]';
        if (oldInput.value !== '') {
          selector += '[value="' + CSS.escape(oldInput.value) + '"]';
        }
        var newInput = doc.querySelector(selector);
        if (!newInput) return;
        oldInput.disabled = newInput.disabled;
        var oldLabel = oldInput.closest('.collection-page__filter-label');
        var newLabel = newInput.closest('.collection-page__filter-label');
        if (oldLabel && newLabel) {
          var oldCount = oldLabel.querySelector('.collection-page__filter-count');
          var newCount = newLabel.querySelector('.collection-page__filter-count');
          if (oldCount && newCount) oldCount.textContent = newCount.textContent;
        }
      });
    }

    function applyFilters() {
      var targetUrl = buildFilterUrl();
      if (!targetUrl) return;
      var mainArea = document.querySelector('.collection-page__main');
      if (mainArea) mainArea.classList.add('is-loading');
      fetch(targetUrl, { credentials: 'same-origin' })
        .then(function(res) { return res.text(); })
        .then(function(html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          refreshMainResults(doc);
          refreshToolbarCount(doc);
          refreshFilterBadge(doc);
          refreshSidebarHeader(doc);
          refreshFilterCounts(doc);
          window.history.pushState({}, '', targetUrl);
          var mainAfter = document.querySelector('.collection-page__main');
          if (mainAfter) mainAfter.classList.remove('is-loading');
          window.dispatchEvent(new Event('collection:swapped'));
        })
        .catch(function() {
          window.location.href = targetUrl;
        });
    }

    if (form) {
      var debounceTimer;
      form.addEventListener('change', function() {
        /* Mobile drawer: batch changes, apply on Done */
        if (sidebar && sidebar.classList.contains('is-open')) {
          pendingFilterChange = true;
          return;
        }
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(applyFilters, 500);
      });
    }

    /* Mobile filter drawer */
    var sidebar = document.querySelector('[data-filters-sidebar]');
    var openBtn = document.querySelector('[data-filters-open]');
    var closeBtn = document.querySelector('[data-filters-close]');
    var savedScrollY = 0;

    function lockBodyScroll() {
      savedScrollY = window.scrollY || window.pageYOffset || 0;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + savedScrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }

    function unlockBodyScroll() {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      // Instant: the site's smooth scrolling would otherwise animate back down.
      window.scrollTo({ top: savedScrollY, left: 0, behavior: 'instant' });
    }

    if (sidebar && openBtn) {
      openBtn.addEventListener('click', function() {
        sidebar.classList.add('is-open');
        lockBodyScroll();
      });
    }
    if (sidebar && closeBtn) {
      closeBtn.addEventListener('click', function() {
        sidebar.classList.remove('is-open');
        unlockBodyScroll();
        if (pendingFilterChange) {
          pendingFilterChange = false;
          applyFilters();
        }
      });
    }

    /* View toggle (grid / list) -- re-queries grid each call so it survives AJAX swaps */
    var viewBtns = document.querySelectorAll('[data-view]');

    function applyView(view) {
      var grid = document.querySelector('.collection-page__grid');
      if (grid) grid.classList.toggle('collection-page__grid--list', view === 'list');
      viewBtns.forEach(function(b) {
        b.classList.toggle('collection-page__view-btn--active', b.getAttribute('data-view') === view);
      });
    }

    if (viewBtns.length) {
      var savedView = localStorage.getItem('collection-view') || 'grid';
      applyView(savedView);

      viewBtns.forEach(function(btn) {
        btn.addEventListener('click', function() {
          var view = btn.getAttribute('data-view');
          localStorage.setItem('collection-view', view);
          applyView(view);
        });
      });

      /* Restore saved view after any AJAX section swap */
      window.addEventListener('collection:swapped', function() {
        applyView(localStorage.getItem('collection-view') || 'grid');
      });
    }

    /* Brand band: desktop prev/next scroll arrows (scrollbar is hidden) */
    document.querySelectorAll('[data-brand-band]').forEach(function(band) {
      var scroller = band.querySelector('[data-brand-scroll]');
      var prev = band.querySelector('[data-brand-scroll-prev]');
      var next = band.querySelector('[data-brand-scroll-next]');
      if (!scroller || !prev || !next) return;

      function update() {
        var maxLeft = scroller.scrollWidth - scroller.clientWidth;
        band.classList.toggle('brand-band--scrollable', maxLeft > 1);
        prev.disabled = scroller.scrollLeft <= 1;
        next.disabled = scroller.scrollLeft >= maxLeft - 1;
      }
      function step(dir) {
        var amount = Math.max(scroller.clientWidth * 0.8, 200);
        scroller.scrollBy({ left: dir * amount, behavior: 'smooth' });
      }

      prev.addEventListener('click', function() { step(-1); });
      next.addEventListener('click', function() { step(1); });
      scroller.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      window.addEventListener('load', update);
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var carousel = document.querySelector('[data-testimonials-carousel]');
    if (!carousel) return;

    var track = carousel.querySelector('[data-testimonials-track]');
    var prev = carousel.querySelector('[data-testimonials-prev]');
    var next = carousel.querySelector('[data-testimonials-next]');
    var scrollAmount = 320;

    if (prev) prev.addEventListener('click', function() {
      track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });

    if (next) next.addEventListener('click', function() {
      track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deals-brand-nav"]) return;
  try {
    
  (function() {
    var band = document.querySelector('[data-deals-brand-band]');
    if (!band) return;

    var scroller = band.querySelector('[data-deals-scroll]');
    var prevBtn = band.querySelector('[data-deals-scroll-prev]');
    var nextBtn = band.querySelector('[data-deals-scroll-next]');

    function updateArrows() {
      if (!scroller || !prevBtn || !nextBtn) return;
      var maxLeft = scroller.scrollWidth - scroller.clientWidth;
      band.classList.toggle('deals-nav--scrollable', maxLeft > 1);
      prevBtn.disabled = scroller.scrollLeft <= 1;
      nextBtn.disabled = scroller.scrollLeft >= maxLeft - 1;
    }

    var desktop = window.matchMedia('(hover: hover) and (pointer: fine)');
    var perView = 0;

    /* Desktop: spread the gap so a whole number of circles fills the row. With
       circles snapping to the left edge, every scroll position (including the
       very end) then shows whole circles only, never one cut in half. Phones
       keep the natural gap: a partly visible circle there hints at swiping. */
    function fitRow() {
      if (!scroller) return;
      scroller.style.gap = '';
      perView = 0;
      if (!desktop.matches) return;
      var items = scroller.querySelectorAll('.deals-nav__brand');
      if (items.length < 2) return;
      var itemWidth = items[0].getBoundingClientRect().width;
      var minGap = parseFloat(getComputedStyle(scroller).columnGap) || 16;
      var available = scroller.clientWidth;
      var count = Math.max(1, Math.floor((available + minGap) / (itemWidth + minGap)));
      if (count >= items.length) return;
      perView = count;
      if (count > 1) scroller.style.gap = ((available - count * itemWidth) / (count - 1)) + 'px';
    }

    function step(dir) {
      if (!scroller) return;
      var items = scroller.querySelectorAll('.deals-nav__brand');
      var amount = Math.max(scroller.clientWidth * 0.8, 200);
      if (perView > 1 && items.length > 1) {
        /* Move by whole circles, keeping one from the previous view for context */
        var pitch = items[1].getBoundingClientRect().left - items[0].getBoundingClientRect().left;
        amount = (perView - 1) * pitch;
      }
      scroller.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }

    /* Centre the selected brand -- in a single scrolling row it can sit off-screen.
       Adjusts scrollLeft directly rather than calling scrollIntoView, which would also
       scroll the window: the nav sits below the hero and is off-screen at load. */
    function revealActive() {
      if (!scroller) return;
      var active = band.querySelector('.deals-nav__brand.is-active');
      if (!active) return;
      var activeBox = active.getBoundingClientRect();
      var scrollBox = scroller.getBoundingClientRect();
      var delta = activeBox.left - scrollBox.left - (scrollBox.width - activeBox.width) / 2;
      scroller.scrollLeft += delta;
    }

    function selectedVendors() {
      return new URLSearchParams(window.location.search).getAll('filter.p.vendor');
    }

    /* Mirror the URL onto the circles -- the sidebar Brand filter changes it too */
    function syncActiveFromUrl() {
      var vendors = selectedVendors();
      band.querySelectorAll('[data-brand-link]').forEach(function(link) {
        var vendor = link.getAttribute('data-vendor') || '';
        var on = vendor === '' ? vendors.length === 0 : vendors.indexOf(vendor) !== -1;
        link.classList.toggle('is-active', on);
      });
    }

    /* Keep the sidebar checkboxes in step: the collection section rebuilds every
       filter.* param from that form, so an unchecked box would silently drop the
       brand on the next sidebar interaction. */
    function syncSidebarVendor(vendor) {
      document.querySelectorAll('[data-filter-input][type="checkbox"][name="filter.p.vendor"]').forEach(function(input) {
        input.checked = vendor !== '' && input.value === vendor;
      });
    }

    function bindBrandLinks() {
      band.querySelectorAll('[data-brand-link]').forEach(function(link) {
        if (link.dataset.bound) return;
        link.dataset.bound = '1';
        link.addEventListener('click', function(e) {
          e.preventDefault();
          var url = link.getAttribute('href');
          var vendor = link.getAttribute('data-vendor') || '';

          /* Immediate visual feedback */
          band.querySelectorAll('[data-brand-link]').forEach(function(l) {
            l.classList.remove('is-active');
          });
          link.classList.add('is-active');
          syncSidebarVendor(vendor);

          var main = document.querySelector('.collection-page__main');
          if (main) main.classList.add('is-loading');

          fetch(url, { credentials: 'same-origin', cache: 'no-store' })
            .then(function(res) { return res.text(); })
            .then(function(html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');

              /* Swap main grid + toolbar count. The brand row itself is identical on
                 every response, so it is left alone -- re-rendering it would destroy
                 the bound arrow buttons. */
              var oldMain = document.querySelector('.collection-page__main');
              var newMain = doc.querySelector('.collection-page__main');
              if (oldMain && newMain) {
                var oldLines = oldMain.querySelector('.collection-page__lines');
                Array.from(oldMain.children).forEach(function(c) {
                  if (c !== oldLines) c.remove();
                });
                Array.from(newMain.children).forEach(function(c) {
                  if (!c.classList.contains('collection-page__lines')) {
                    oldMain.appendChild(c);
                  }
                });
              }

              var oldCount = document.querySelector('.collection-page__count');
              var newCount = doc.querySelector('.collection-page__count');
              if (oldCount && newCount) oldCount.textContent = newCount.textContent;

              window.history.pushState({}, '', url);

              if (oldMain) oldMain.classList.remove('is-loading');
              window.dispatchEvent(new Event('collection:swapped'));
            })
            .catch(function() {
              window.location.href = url;
            });
        });
      });
    }

    if (scroller && prevBtn && nextBtn) {
      prevBtn.addEventListener('click', function() { step(-1); });
      nextBtn.addEventListener('click', function() { step(1); });
      scroller.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', function() { fitRow(); updateArrows(); });
      window.addEventListener('load', function() { fitRow(); updateArrows(); });
    }

    /* Sidebar filters and sort also swap the grid; re-read the URL so the circles
       and the arrow state stay truthful. */
    window.addEventListener('collection:swapped', function() {
      syncActiveFromUrl();
      updateArrows();
    });

    window.addEventListener('popstate', syncActiveFromUrl);

    bindBrandLinks();
    fitRow();
    revealActive();
    updateArrows();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('.featured-products');
    var carousel = document.querySelector('[data-product-carousel]');
    if (!section || !carousel) return;

    var track = carousel.querySelector('[data-product-track]');
    var prev = section.querySelector('[data-carousel-prev]');
    var next = section.querySelector('[data-carousel-next]');
    if (!track) return;

    function step() {
      var item = track.querySelector('.featured-products__item');
      return item ? item.getBoundingClientRect().width + 20 : 300;
    }

    // Arrows show only when the row overflows, and disable at each end.
    function update() {
      var maxLeft = track.scrollWidth - track.clientWidth;
      section.classList.toggle('featured-products--scrollable', maxLeft > 1);
      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft >= maxLeft - 1;
    }

    if (prev) prev.addEventListener('click', function() {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function() {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    window.addEventListener('load', update);
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    var header = document.querySelector('[data-header]');
    var toggle = document.querySelector('[data-mobile-menu-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');

    /*
      Desktop: past COMPACT_AT the nav row collapses and a menu button appears
      by the logo. The button reopens the nav, which then stays open while
      scrolling until closed. Back at the top everything resets. The gap
      between the two thresholds stops the header flickering as its height
      changes.
    */
    var COMPACT_AT = 120;
    var EXPAND_AT = 10;
    var desktop = window.matchMedia('(min-width: 769px)');
    var navToggle = header ? header.querySelector('[data-nav-toggle]') : null;
    var compact = false;
    var ticking = false;

    function setNavOpen(open) {
      if (!navToggle) return;
      header.classList.toggle('header--nav-open', open);
      navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      navToggle.setAttribute('aria-label', navToggle.getAttribute(open ? 'data-label-close' : 'data-label-open'));
    }

    function setCompact(on) {
      if (compact === on) return;
      compact = on;
      header.classList.toggle('header--compact', on);
      if (!on) setNavOpen(false);
    }

    function onScroll() {
      ticking = false;
      // A drawer has pinned the page (body position: fixed), which reports a
      // scroll of 0. Keep the header as it was until the page is released.
      if (document.body.style.position === 'fixed') return;
      var y = window.scrollY;
      header.classList.toggle('header--scrolled', y > EXPAND_AT);
      if (!desktop.matches) {
        setCompact(false);
      } else if (y > COMPACT_AT) {
        setCompact(true);
      } else if (y < EXPAND_AT) {
        setCompact(false);
      }
    }

    if (header) {
      window.addEventListener('scroll', function() {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(onScroll);
        }
      }, { passive: true });
      desktop.addEventListener('change', onScroll);
      onScroll();
    }

    if (navToggle) {
      navToggle.addEventListener('click', function() {
        setNavOpen(!header.classList.contains('header--nav-open'));
      });
    }

    var searchToggle = document.querySelector('[data-search-toggle]');
    if (searchToggle && header) {
      searchToggle.addEventListener('click', function() {
        var isOpen = header.classList.toggle('header--search-open');
        searchToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (isOpen) {
          var input = header.querySelector('.header__search-input');
          if (input) {
            input.focus();
          }
        }
      });
    }

    function closeMenu() {
      menu.classList.remove('is-open');
      document.body.style.overflow = '';
      var panels = menu.querySelectorAll('[data-menu-panel]');
      panels.forEach(function(p) {
        p.classList.remove('is-active', 'slide-in-right', 'slide-in-left');
      });
      var root = menu.querySelector('[data-menu-panel="root"]');
      if (root) root.classList.add('is-active');
    }

    if (toggle && menu) {
      toggle.addEventListener('click', function() {
        var isOpen = menu.classList.toggle('is-open');
        document.body.style.overflow = isOpen ? 'hidden' : '';
        if (!isOpen) {
          closeMenu();
        }
      });

      var closeBtn = menu.querySelector('[data-mobile-menu-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', closeMenu);
      }

      /* Drill into sub-panel */
      menu.addEventListener('click', function(e) {
        var openBtn = e.target.closest('[data-menu-open]');
        if (openBtn) {
          var targetId = openBtn.getAttribute('data-menu-open');
          var currentPanel = openBtn.closest('[data-menu-panel]');
          var targetPanel = menu.querySelector('[data-menu-panel="' + targetId + '"]');
          if (currentPanel && targetPanel) {
            currentPanel.classList.remove('is-active');
            targetPanel.classList.remove('slide-in-left');
            targetPanel.classList.add('is-active', 'slide-in-right');
          }
        }

        /* Back button */
        var backBtn = e.target.closest('[data-menu-back]');
        if (backBtn) {
          var currentPanel = backBtn.closest('[data-menu-panel]');
          var currentId = currentPanel.getAttribute('data-menu-panel');
          /* Find parent panel by locating the button that opens this one */
          var parentId = 'root';
          var opener = menu.querySelector('[data-menu-open="' + currentId + '"]');
          if (opener) {
            var parentPanel = opener.closest('[data-menu-panel]');
            if (parentPanel) parentId = parentPanel.getAttribute('data-menu-panel');
          }
          var parent = menu.querySelector('[data-menu-panel="' + parentId + '"]');
          if (currentPanel && parent) {
            currentPanel.classList.remove('is-active', 'slide-in-right');
            parent.classList.remove('slide-in-right');
            parent.classList.add('is-active', 'slide-in-left');
          }
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var slideshow = document.querySelector('[data-slideshow]');
    if (!slideshow) return;

    var slides = slideshow.querySelectorAll('.hero-slideshow__slide');
    var current = 0;
    var total = slides.length;
    if (total <= 1) return;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      current = (index + total) % total;
      slides[current].classList.add('is-active');
    }

    var prev = slideshow.querySelector('[data-slideshow-prev]');
    var next = slideshow.querySelector('[data-slideshow-next]');
    var autoplayEnabled = slideshow.getAttribute('data-autoplay') === 'true';
    var autoplaySpeed = parseInt(slideshow.getAttribute('data-autoplay-speed'), 10) * 1000 || 5000;
    var autoplayInterval;

    function startAutoplay() {
      if (!autoplayEnabled) return;
      autoplayInterval = setInterval(function() { goTo(current + 1); }, autoplaySpeed);
    }

    function stopAutoplay() {
      clearInterval(autoplayInterval);
    }

    if (prev) prev.addEventListener('click', function() { stopAutoplay(); goTo(current - 1); startAutoplay(); });
    if (next) next.addEventListener('click', function() { stopAutoplay(); goTo(current + 1); startAutoplay(); });

    startAutoplay();
    slideshow.addEventListener('mouseenter', stopAutoplay);
    slideshow.addEventListener('mouseleave', startAutoplay);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["judgeme-carousel"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-reviews-carousel]').forEach(function(section) {
      var track = section.querySelector('[data-reviews-track]');
      var prev = section.querySelector('[data-reviews-prev]');
      var next = section.querySelector('[data-reviews-next]');
      if (!track) return;

      function step() {
        var item = track.querySelector('.judgeme-carousel__item');
        return item ? item.getBoundingClientRect().width + 20 : 300;
      }

      // Arrows show only when the row overflows, and disable at each end.
      function update() {
        var maxLeft = track.scrollWidth - track.clientWidth;
        section.classList.toggle('judgeme-carousel--scrollable', maxLeft > 1);
        if (prev) prev.disabled = track.scrollLeft <= 1;
        if (next) next.disabled = track.scrollLeft >= maxLeft - 1;
      }

      if (prev) prev.addEventListener('click', function() {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function() {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      window.addEventListener('load', update);
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["judgeme-reviews"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('.judgeme-reviews--empty');
    if (!section) return;
    var findJudgeMeButton = function() {
      return section.querySelector('.jm-no-reviews-state__action-buttons button, .jm-action-buttons__button, .jdgm-write-rev-link');
    };
    var trigger = section.querySelector('[data-judgeme-write-review]');
    if (trigger) {
      trigger.addEventListener('click', function() {
        var button = findJudgeMeButton();
        if (button) {
          button.click();
        } else {
          section.classList.add('is-fallback');
        }
      });
    }
    // If Judge.me hasn't drawn its widget after a while, show it as normal.
    setTimeout(function() {
      if (!findJudgeMeButton()) section.classList.add('is-fallback');
    }, 8000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lifestyle-band"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initLifestyleLightbox(band) {
      var lightbox = band.querySelector('[data-lifestyle-lightbox]');
      if (!lightbox) return;

      var imgs = lightbox.querySelectorAll('[data-lifestyle-lightbox-slide]');
      var counter = lightbox.querySelector('[data-lifestyle-lightbox-counter]');
      var closeBtn = lightbox.querySelector('[data-lifestyle-lightbox-close]');
      var prevBtn = lightbox.querySelector('[data-lifestyle-lightbox-prev]');
      var nextBtn = lightbox.querySelector('[data-lifestyle-lightbox-next]');
      var openers = band.querySelectorAll('[data-lifestyle-open]');
      var current = 0;
      var lastFocus = null;

      function show(i) {
        if (i < 0) i = imgs.length - 1;
        if (i >= imgs.length) i = 0;
        current = i;
        imgs.forEach(function(img, idx) {
          img.classList.toggle('is-active', idx === i);
        });
        if (counter) counter.textContent = (i + 1) + ' / ' + imgs.length;
      }

      function open(i) {
        lastFocus = document.activeElement;
        show(i);
        lightbox.hidden = false;
        document.body.style.overflow = 'hidden';
        void lightbox.offsetWidth;
        lightbox.classList.add('is-open');
        if (closeBtn) closeBtn.focus();
      }

      function close() {
        lightbox.classList.remove('is-open');
        document.body.style.overflow = '';
        var done = function() {
          lightbox.hidden = true;
          lightbox.removeEventListener('transitionend', done);
        };
        lightbox.addEventListener('transitionend', done);
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }

      openers.forEach(function(btn) {
        btn.addEventListener('click', function() {
          open(parseInt(btn.getAttribute('data-lifestyle-open'), 10) || 0);
        });
      });

      if (closeBtn) closeBtn.addEventListener('click', close);
      if (prevBtn) prevBtn.addEventListener('click', function() { show(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function() { show(current + 1); });

      lightbox.addEventListener('click', function(e) {
        if (e.target.closest('[data-lifestyle-lightbox-slide]')) return;
        if (e.target.closest('button')) return;
        close();
      });

      document.addEventListener('keydown', function(e) {
        if (lightbox.hidden) return;
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowLeft') show(current - 1);
        else if (e.key === 'ArrowRight') show(current + 1);
      });
    }

    document.querySelectorAll('[data-lifestyle-band]').forEach(initLifestyleLightbox);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-discovery"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-product-discovery]').forEach(function(root) {
      var tablist = root.querySelector('[data-discovery-tablist]');
      var viewAll = root.querySelector('[data-discovery-view-all]');

      function tabs() {
        return Array.prototype.filter.call(root.querySelectorAll('[data-discovery-tab]'), function(t) {
          return !t.hidden;
        });
      }

      function select(name) {
        root.querySelectorAll('[data-discovery-tab]').forEach(function(tab) {
          var active = tab.getAttribute('data-discovery-tab') === name;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        root.querySelectorAll('[data-discovery-panel]').forEach(function(panel) {
          panel.hidden = panel.getAttribute('data-discovery-panel') !== name;
        });
        if (viewAll) viewAll.hidden = name !== 'brand';
      }

      function refreshTabs() {
        var visible = tabs();
        if (visible.length === 0) {
          root.hidden = true;
          return;
        }
        tablist.classList.toggle('is-single', visible.length === 1);
        if (!visible.some(function(t) { return t.classList.contains('is-active'); })) {
          select(visible[0].getAttribute('data-discovery-tab'));
        }
      }

      root.querySelectorAll('[data-discovery-tab]').forEach(function(tab) {
        tab.addEventListener('click', function() {
          if (tabs().length > 1) select(tab.getAttribute('data-discovery-tab'));
        });
        tab.addEventListener('keydown', function(event) {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          var visible = tabs();
          var index = visible.indexOf(tab) + (event.key === 'ArrowRight' ? 1 : -1);
          var target = visible[(index + visible.length) % visible.length];
          select(target.getAttribute('data-discovery-tab'));
          target.focus();
        });
      });

      root.querySelectorAll('[data-discovery-carousel]').forEach(function(carousel) {
        var track = carousel.querySelector('[data-discovery-track]');
        var prev = carousel.querySelector('[data-discovery-prev]');
        var next = carousel.querySelector('[data-discovery-next]');
        if (prev) prev.addEventListener('click', function() {
          track.scrollBy({ left: -300, behavior: 'smooth' });
        });
        if (next) next.addEventListener('click', function() {
          track.scrollBy({ left: 300, behavior: 'smooth' });
        });
      });

      var brandTab = root.querySelector('[data-discovery-tab="brand"]');
      select(brandTab ? 'brand' : 'recs');
      refreshTabs();

      var recsTab = root.querySelector('[data-discovery-tab="recs"]');
      var recsTrack = root.querySelector('[data-discovery-recs-track]');
      fetch(root.getAttribute('data-recs-url'))
        .then(function(response) { return response.text(); })
        .then(function(html) {
          var temp = document.createElement('div');
          temp.innerHTML = html;
          var content = temp.querySelector('[data-discovery-recs-content]');
          if (content && content.children.length > 0) {
            recsTrack.innerHTML = content.innerHTML;
            recsTab.hidden = false;
          }
          refreshTabs();
        })
        .catch(refreshTabs);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  (function() {
    // Scoped: Judge.me's review widget also carries data-product-id.
    var container = document.querySelector('.product-recommendations[data-product-id]');
    if (!container) return;

    var productId = container.getAttribute('data-product-id');
    var sectionId = 'product-recommendations';
    var url = '/recommendations/products?product_id=' + productId + '&limit=8&section_id=' + sectionId;

    fetch(url)
      .then(function(response) { return response.text(); })
      .then(function(html) {
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var newContent = temp.querySelector('.product-recommendations');
        if (newContent && newContent.innerHTML.trim() !== '') {
          container.innerHTML = newContent.innerHTML;
          initCarousel();
        }
      })
      .catch(function() {});

    function initCarousel() {
      var track = container.querySelector('[data-recs-track]');
      var prev = container.querySelector('[data-recs-prev]');
      var next = container.querySelector('[data-recs-next]');
      if (!track) return;

      var scrollAmount = 300;
      if (prev) prev.addEventListener('click', function() {
        track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function() {
        track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function() {
    /* --- Parse variant data --- */
    var jsonEl = document.querySelector('[data-product-json]');
    var variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
    var stockJsonEl = document.querySelector('[data-product-stock]');
    var lowStock = stockJsonEl ? JSON.parse(stockJsonEl.textContent) : {};
    var stockEl = document.querySelector('[data-stock]');

    /* In stock / only N left / out of stock for the selected variant */
    function updateStock(variant) {
      if (!stockEl) return;
      var textEl = stockEl.querySelector('[data-stock-text]');
      var state = 'out';
      var text = stockEl.getAttribute('data-text-out');
      if (variant.available) {
        var qty = lowStock[String(variant.id)];
        if (typeof qty === 'number' && qty > 0) {
          state = 'low';
          text = stockEl.getAttribute('data-text-low').replace('__qty__', qty);
        } else {
          state = 'in';
          text = stockEl.getAttribute('data-text-in');
        }
      }
      stockEl.classList.remove('product-page__stock--in', 'product-page__stock--low', 'product-page__stock--out');
      stockEl.classList.add('product-page__stock--' + state);
      if (textEl) textEl.textContent = text;
    }

    /* --- Elements --- */
    var thumbs = document.querySelectorAll('[data-thumb]');
    var mainImg = document.getElementById('product-main-img');
    var optionBtns = document.querySelectorAll('[data-option-value]');
    var variantSelect = document.querySelector('[data-variant-select]');
    var addBtn = document.querySelector('.product-page__add-btn');
    var priceEl = document.querySelector('[data-price]');
    var compareEl = document.querySelector('[data-compare-price]');
    var discountPctEl = document.querySelector('[data-discount-pct]');

    /* --- Thumbnails --- */
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        thumbs.forEach(function(t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (mainImg) {
          mainImg.removeAttribute('srcset');
          mainImg.src = thumb.getAttribute('data-image-url');
        }
      });
    });

    /* --- Quantity stepper --- */
    var minusBtn = document.querySelector('[data-qty-minus]');
    var plusBtn = document.querySelector('[data-qty-plus]');
    var qtyInput = document.querySelector('[data-qty-input]');
    if (minusBtn && plusBtn && qtyInput) {
      minusBtn.addEventListener('click', function() {
        var val = parseInt(qtyInput.value, 10);
        if (val > 1) qtyInput.value = val - 1;
      });
      plusBtn.addEventListener('click', function() {
        qtyInput.value = parseInt(qtyInput.value, 10) + 1;
      });
    }

    /* --- Variant selection --- */
    function getSelectedOptions() {
      var selected = [];
      document.querySelectorAll('[data-option-group]').forEach(function(group) {
        var activeBtn = group.querySelector('.is-selected');
        if (activeBtn) selected.push(activeBtn.getAttribute('data-option-value'));
      });
      return selected;
    }

    function findVariant(options) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < options.length; j++) {
          if (v.options[j] !== options[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function updateVariant(variant) {
      if (!variant) return;

      if (variantSelect) variantSelect.value = variant.id;

      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
          if (discountPctEl) {
            var pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
            discountPctEl.textContent = pct + '% off';
            discountPctEl.style.display = '';
          }
        } else {
          compareEl.style.display = 'none';
          if (discountPctEl) discountPctEl.style.display = 'none';
        }
      }

      updateStock(variant);

      if (addBtn) {
        var qtyWrap = document.querySelector('[data-qty-wrap]');
        var notifyWrap = document.querySelector('[data-notify-wrap]');

        if (variant.available) {
          addBtn.style.display = '';
          addBtn.disabled = false;
          addBtn.textContent = addBtn.getAttribute('data-add-text');
          if (qtyWrap) qtyWrap.style.display = '';
          if (notifyWrap) notifyWrap.style.display = 'none';
        } else {
          addBtn.style.display = 'none';
          if (qtyWrap) qtyWrap.style.display = 'none';
          if (notifyWrap) {
            notifyWrap.style.display = '';
            var notifyFormEl = notifyWrap.querySelector('[data-notify-form]');
            if (notifyFormEl) {
              notifyFormEl.setAttribute('data-variant-title', variant.title);
            }
          }
        }
      }

      if (variant.featured_image && mainImg) {
        mainImg.removeAttribute('srcset');
        mainImg.src = variant.featured_image.src;
        thumbs.forEach(function(t) {
          t.classList.remove('is-active');
          if (t.getAttribute('data-image-url').indexOf(variant.featured_image.src.split('?')[0].split('/').pop()) > -1) {
            t.classList.add('is-active');
          }
        });

        var swipeGal = document.querySelector('[data-swipe-gallery]');
        if (swipeGal) {
          var swipeImgs = swipeGal.querySelectorAll('.product-page__swipe-img');
          var fileName = variant.featured_image.src.split('?')[0].split('/').pop();
          for (var si = 0; si < swipeImgs.length; si++) {
            if (swipeImgs[si].src.indexOf(fileName) > -1) {
              var slide = swipeImgs[si].closest('.product-page__swipe-slide');
              if (slide) slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
              var sDots = document.querySelectorAll('[data-swipe-dot]');
              for (var sd = 0; sd < sDots.length; sd++) sDots[sd].classList.remove('is-active');
              if (sDots[si]) sDots[si].classList.add('is-active');
              break;
            }
          }
        }
      }

      document.dispatchEvent(new CustomEvent('product:variant-change', {
        detail: { variantId: variant.id, scope: document.querySelector('.product-page') }
      }));

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    function updateAvailability() {
      var selected = getSelectedOptions();
      document.querySelectorAll('[data-option-group]').forEach(function(group) {
        var groupIndex = parseInt(group.getAttribute('data-option-group'), 10);
        group.querySelectorAll('[data-option-value]').forEach(function(btn) {
          var val = btn.getAttribute('data-option-value');
          var hasAvailable = false;
          for (var i = 0; i < variants.length; i++) {
            if (variants[i].options[groupIndex] !== val) continue;
            var match = true;
            for (var j = 0; j < selected.length; j++) {
              if (j === groupIndex) continue;
              if (variants[i].options[j] !== selected[j]) { match = false; break; }
            }
            if (match && variants[i].available) { hasAvailable = true; break; }
          }
          if (hasAvailable) {
            btn.classList.remove('is-unavailable');
          } else {
            btn.classList.add('is-unavailable');
          }
        });
      });
    }

    optionBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var group = btn.closest('[data-option-group]');
        group.querySelectorAll('.is-selected').forEach(function(b) {
          b.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');

        var index = btn.getAttribute('data-option-index');
        var label = document.querySelector('[data-option-selected="' + index + '"]');
        if (label) label.textContent = btn.getAttribute('data-option-value');

        var selected = getSelectedOptions();
        var variant = findVariant(selected);
        if (variant) updateVariant(variant);
        updateAvailability();
      });
    });

    /* --- Lightbox --- */
    var lightbox = document.querySelector('[data-lightbox]');
    var lightboxImg = lightbox ? lightbox.querySelector('[data-lightbox-img]') : null;
    var imageUrls = [];
    var currentImageIndex = 0;

    thumbs.forEach(function(t) {
      imageUrls.push(t.getAttribute('data-image-url'));
    });
    if (imageUrls.length === 0 && mainImg) {
      imageUrls.push(mainImg.src);
    }

    function openLightbox(index) {
      if (!lightbox || imageUrls.length === 0) return;
      currentImageIndex = index;
      lightboxImg.src = imageUrls[index];
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
      if (!lightbox) return;
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    if (lightbox) {
      var closeBtn = lightbox.querySelector('[data-lightbox-close]');
      var prevBtn = lightbox.querySelector('[data-lightbox-prev]');
      var nextBtn = lightbox.querySelector('[data-lightbox-next]');

      if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          currentImageIndex = (currentImageIndex - 1 + imageUrls.length) % imageUrls.length;
          lightboxImg.src = imageUrls[currentImageIndex];
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          currentImageIndex = (currentImageIndex + 1) % imageUrls.length;
          lightboxImg.src = imageUrls[currentImageIndex];
        });
      }
      lightbox.addEventListener('click', function(e) {
        if (e.target === lightbox) closeLightbox();
      });

      document.addEventListener('keydown', function(e) {
        if (!lightbox.classList.contains('is-open')) return;
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowLeft' && prevBtn) prevBtn.click();
        if (e.key === 'ArrowRight' && nextBtn) nextBtn.click();
      });
    }

    /* --- Main image click opens lightbox --- */
    var zoomContainer = document.querySelector('[data-zoom-container]');
    if (zoomContainer) {
      zoomContainer.addEventListener('click', function() {
        var activeThumb = document.querySelector('[data-thumb].is-active');
        var index = activeThumb ? parseInt(activeThumb.getAttribute('data-image-index'), 10) : 0;
        openLightbox(index);
      });
    }

    /* --- Mobile swipe gallery tap opens lightbox --- */
    var swipeSlides = document.querySelectorAll('.product-page__swipe-slide');
    swipeSlides.forEach(function(slide, i) {
      slide.addEventListener('click', function() {
        openLightbox(i);
      });
      slide.style.cursor = 'zoom-in';
    });

    /* --- Mobile swipe dots --- */
    var swipeGallery = document.querySelector('[data-swipe-gallery]');
    var swipeDots = document.querySelectorAll('[data-swipe-dot]');
    if (swipeGallery && swipeDots.length > 0) {
      var dotTimeout;
      swipeGallery.addEventListener('scroll', function() {
        clearTimeout(dotTimeout);
        dotTimeout = setTimeout(function() {
          var slides = swipeGallery.querySelectorAll('.product-page__swipe-slide');
          var center = swipeGallery.scrollLeft + swipeGallery.offsetWidth / 2;
          var activeIdx = 0;
          for (var i = 0; i < slides.length; i++) {
            if (slides[i].offsetLeft + slides[i].offsetWidth / 2 <= center) activeIdx = i;
          }
          for (var j = 0; j < swipeDots.length; j++) swipeDots[j].classList.remove('is-active');
          if (swipeDots[activeIdx]) swipeDots[activeIdx].classList.add('is-active');
        }, 50);
      });

      swipeDots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          var idx = parseInt(dot.getAttribute('data-swipe-dot'), 10);
          var slides = swipeGallery.querySelectorAll('.product-page__swipe-slide');
          if (slides[idx]) {
            slides[idx].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
          }
        });
      });
    }

    /* --- Back-in-stock notify form --- */
    var notifyWrap = document.querySelector('[data-notify-wrap]');
    var notifyRow = notifyWrap ? notifyWrap.querySelector('[data-notify-form]') : null;
    if (notifyRow) {
      var notifyEmailInput = notifyRow.querySelector('[data-notify-email]');
      var notifySubmitBtn = notifyRow.querySelector('[data-notify-submit]');
      var successEl = document.querySelector('[data-notify-success]');
      var errorEl = document.querySelector('[data-notify-error]');
      var originalBtnText = notifySubmitBtn ? notifySubmitBtn.textContent.trim() : '';

      notifySubmitBtn.addEventListener('click', function() {
        var email = notifyEmailInput.value.trim();
        if (!email || !notifyEmailInput.validity.valid) {
          notifyEmailInput.reportValidity();
          return;
        }

        notifySubmitBtn.disabled = true;
        notifySubmitBtn.textContent = '...';
        if (errorEl) errorEl.style.display = 'none';

        var productTitle = notifyRow.getAttribute('data-product-title');
        var productUrl = notifyRow.getAttribute('data-product-url');
        var variantTitle = notifyRow.getAttribute('data-variant-title');
        var body = 'Back in stock request: ' + productTitle + ' (' + variantTitle + '). Product URL: ' + productUrl;

        fetch('/contact', {
          method: 'POST',
          body: new URLSearchParams({
            'form_type': 'contact',
            'utf8': '\u2713',
            'contact[email]': email,
            'contact[body]': body,
            'contact[tags]': 'back-in-stock',
          }),
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        })
        .then(function() {
          notifyRow.style.display = 'none';
          if (successEl) successEl.style.display = '';
        })
        .catch(function() {
          if (errorEl) errorEl.style.display = '';
          notifySubmitBtn.disabled = false;
          notifySubmitBtn.textContent = originalBtnText;
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"]) return;
  try {
    
  (function() {
    var section = document.querySelector('[data-recently-viewed]');
    if (!section) return;

    var currentHandle = section.getAttribute('data-current-handle');
    var storageKey = 'recently-viewed';
    var maxItems = 10;

    /* Save current product */
    var currentProduct = {
      handle: currentHandle,
      title: section.getAttribute('data-current-title'),
      url: section.getAttribute('data-current-url'),
      vendor: section.getAttribute('data-current-vendor'),
      price: section.getAttribute('data-current-price'),
      image: section.getAttribute('data-current-image')
    };

    if (currentHandle && currentProduct.title) {
      var stored = [];
      try { stored = JSON.parse(localStorage.getItem(storageKey)) || []; } catch(e) {}

      /* Remove duplicate */
      stored = stored.filter(function(p) { return p.handle !== currentHandle; });

      /* Add to front */
      stored.unshift(currentProduct);

      /* Limit */
      if (stored.length > maxItems) stored = stored.slice(0, maxItems);

      localStorage.setItem(storageKey, JSON.stringify(stored));
    }

    /* Render recently viewed (exclude current) */
    var products = [];
    try { products = JSON.parse(localStorage.getItem(storageKey)) || []; } catch(e) {}
    products = products.filter(function(p) { return p.handle !== currentHandle; });

    if (products.length === 0) return;

    var track = section.querySelector('[data-rv-track]');
    var heading = section.querySelector('[data-rv-heading]');
    var carousel = section.querySelector('[data-rv-carousel]');
    if (!track) return;

    var html = '';
    products.forEach(function(p) {
      html += '<div class="recently-viewed__item">';
      html += '<a href="' + p.url + '" class="recently-viewed__card">';
      html += '<div class="recently-viewed__card-image">';
      if (p.image) {
        html += '<img src="' + p.image + '" alt="' + p.title + '" loading="lazy">';
      }
      html += '</div>';
      html += '<div class="recently-viewed__card-info">';
      if (p.vendor) {
        html += '<p class="recently-viewed__card-vendor">' + p.vendor + '</p>';
      }
      html += '<h3 class="recently-viewed__card-title">' + p.title + '</h3>';
      html += '<p class="recently-viewed__card-price">' + p.price + '</p>';
      html += '</div>';
      html += '</a>';
      html += '</div>';
    });

    track.innerHTML = html;
    if (heading) heading.style.display = '';
    if (carousel) carousel.style.display = '';

    /* Carousel arrows */
    var prev = section.querySelector('[data-rv-prev]');
    var next = section.querySelector('[data-rv-next]');
    var scrollAmount = 300;

    if (prev) prev.addEventListener('click', function() {
      track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function() {
      track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-page"] && !Shopify.designMode) return;
  try {
    
  // Photo strip arrows: shown only when the row overflows, disabled at each end
  (function() {
    document.querySelectorAll('[data-review-strip]').forEach(function(wrap) {
      var track = wrap.querySelector('[data-strip-track]');
      var prev = wrap.querySelector('[data-strip-prev]');
      var next = wrap.querySelector('[data-strip-next]');
      if (!track) return;
      function step() {
        var item = track.querySelector('li');
        var width = item ? item.getBoundingClientRect().width + 12 : 200;
        return Math.max(width, Math.floor(track.clientWidth / width) * width);
      }
      function update() {
        var maxLeft = track.scrollWidth - track.clientWidth;
        wrap.classList.toggle('is-scrollable', maxLeft > 1);
        if (prev) prev.disabled = track.scrollLeft <= 1;
        if (next) next.disabled = track.scrollLeft >= maxLeft - 1;
      }
      if (prev) prev.addEventListener('click', function() { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function() { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      window.addEventListener('load', update);
      update();
    });
  })();

  (function() {
    document.querySelectorAll('[data-reviews-page]').forEach(function(root) {
      var perPage = parseInt(root.getAttribute('data-initial-count'), 10) || 12;
      // Shorter first page on phones, where cards stack in one column.
      if (window.matchMedia('(max-width: 640px)').matches) perPage = Math.min(perPage, 6);
      var items = Array.prototype.slice.call(root.querySelectorAll('.reviews-page__item'));
      var filters = root.querySelectorAll('[data-reviews-filter]');
      var more = root.querySelector('[data-reviews-more]');
      var filter = 'all';
      var shown = perPage;

      function render() {
        var matching = 0;
        items.forEach(function(item) {
          var matches = filter === 'all' || item.getAttribute('data-review-type') === filter;
          item.classList.toggle('is-filtered', !matches);
          if (matches) matching++;
          item.classList.toggle('is-collapsed', matches && matching > shown);
        });
        if (more) more.parentElement.hidden = matching <= shown && olderDone;
        // Filter counts follow the reviews loaded so far
        var counts = { all: items.length, store: 0, product: 0 };
        items.forEach(function(item) { counts[item.getAttribute('data-review-type')]++; });
        filters.forEach(function(button) {
          var badge = button.querySelector('span');
          if (badge) badge.textContent = counts[button.getAttribute('data-reviews-filter')];
        });
        updateReadMore();
      }

      // "Read more" only on reviews the line clamp actually cuts off.
      function updateReadMore() {
        root.querySelectorAll('[data-review-text]').forEach(function(text) {
          var button = text.nextElementSibling;
          if (!button || text.classList.contains('is-expanded')) return;
          button.hidden = text.scrollHeight <= text.clientHeight + 2;
        });
      }

      root.querySelectorAll('[data-review-expand]').forEach(function(button) {
        button.addEventListener('click', function() {
          button.previousElementSibling.classList.add('is-expanded');
          button.hidden = true;
        });
      });

      window.addEventListener('resize', updateReadMore);

      filters.forEach(function(button) {
        button.addEventListener('click', function() {
          filter = button.getAttribute('data-reviews-filter');
          shown = perPage;
          filters.forEach(function(other) {
            var active = other === button;
            other.classList.toggle('is-active', active);
            other.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          render();
        });
      });

      // Older reviews: once the reviews built into the page run out, fetch
      // more from Judge.me's public review feed (the one its own widget uses)
      // and add them as cards. Rating-only reviews and duplicates are skipped.
      var olderSource = root.getAttribute('data-older-source');
      var olderPage = 0;
      var olderDone = !olderSource;
      var list = root.querySelector('[data-reviews-list]');
      var seen = {};
      items.forEach(function(item) { seen[item.getAttribute('data-review-id')] = true; });
      var label = function(name) { return root.getAttribute('data-label-' + name) || ''; };

      function matchingCount() {
        return items.filter(function(item) {
          return filter === 'all' || item.getAttribute('data-review-type') === filter;
        }).length;
      }

      function el(tag, className, text) {
        var node = document.createElement(tag);
        if (className) node.className = className;
        if (text) node.textContent = text;
        return node;
      }

      function starsRow(rating) {
        var stars = el('div', 'reviews-page__stars');
        stars.setAttribute('role', 'img');
        stars.setAttribute('aria-label', label('stars').replace('[rating]', rating));
        for (var i = 1; i <= 5; i++) {
          stars.insertAdjacentHTML('beforeend', '<svg class="reviews-page__star' + (i <= rating ? ' is-filled' : '') + '" width="16" height="16" viewBox="0 0 24 24" aria-hidden="true"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26"/></svg>');
        }
        return stars;
      }

      function buildCard(rev) {
        var id = rev.getAttribute('data-review-id');
        var body = rev.querySelector('.jdgm-rev__body');
        var bodyText = body ? body.innerText.trim() : '';
        var titleNode = rev.querySelector('.jdgm-rev__title');
        var titleText = titleNode ? titleNode.textContent.trim() : '';
        if (!id || seen[id] || (!bodyText && !titleText)) return null;
        seen[id] = true;

        var rating = parseInt((rev.querySelector('.jdgm-rev__rating') || {}).getAttribute ? rev.querySelector('.jdgm-rev__rating').getAttribute('data-score') : '0', 10) || 0;
        var author = (rev.querySelector('.jdgm-rev__author') || {}).textContent || '';
        author = author.trim();
        var stamp = rev.querySelector('.jdgm-rev__timestamp');
        var date = stamp ? new Date((stamp.getAttribute('data-content') || '').replace(' UTC', 'Z').replace(' ', 'T')) : null;
        var link = rev.querySelector('.jdgm-rev__prod-link');
        var href = link ? link.getAttribute('href') : '/';
        var isProduct = href && href.indexOf('/products/') !== -1;
        var badge = rev.querySelector('.jdgm-rev__transparency-badge');
        var isGoogle = badge && /google/i.test(badge.getAttribute('data-badge-type') || '');

        var item = el('li', 'reviews-page__item');
        item.setAttribute('data-review-type', isProduct ? 'product' : 'store');
        item.setAttribute('data-review-id', id);
        var card = el('article', 'reviews-page__card');
        var head = el('header', 'reviews-page__card-head');
        var avatar = el('span', 'reviews-page__avatar', (author.charAt(0) || '?').toUpperCase());
        avatar.setAttribute('aria-hidden', 'true');
        var who = el('div', 'reviews-page__who');
        who.appendChild(el('p', 'reviews-page__reviewer', author));
        if (rev.getAttribute('data-verified-buyer') === 'true') {
          var verified = el('p', 'reviews-page__verified');
          verified.insertAdjacentHTML('beforeend', '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>');
          verified.appendChild(document.createTextNode(' ' + label('verified')));
          who.appendChild(verified);
        }
        head.appendChild(avatar);
        head.appendChild(who);
        if (date && !isNaN(date)) {
          var time = el('time', 'reviews-page__date', date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }));
          time.setAttribute('datetime', date.toISOString().slice(0, 10));
          head.appendChild(time);
        }
        card.appendChild(head);
        card.appendChild(starsRow(rating));
        if (titleText) card.appendChild(el('h3', 'reviews-page__title', titleText));
        if (bodyText) {
          var text = el('p', 'reviews-page__text', bodyText);
          text.setAttribute('data-review-text', '');
          var expand = el('button', 'reviews-page__read-more', label('read-more'));
          expand.type = 'button';
          expand.hidden = true;
          expand.addEventListener('click', function() {
            text.classList.add('is-expanded');
            expand.hidden = true;
          });
          card.appendChild(text);
          card.appendChild(expand);
        }
        if (isProduct) {
          var chip = el('a', 'reviews-page__product');
          chip.href = href;
          var chipText = el('span', 'reviews-page__product-text');
          chipText.appendChild(el('span', 'reviews-page__product-label', label('reviewed')));
          chipText.appendChild(el('span', 'reviews-page__product-name', link.textContent.trim()));
          chip.appendChild(chipText);
          chip.insertAdjacentHTML('beforeend', '<svg class="reviews-page__product-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>');
          card.appendChild(chip);
        } else {
          var tag = el('span', 'reviews-page__tag');
          tag.insertAdjacentHTML('beforeend', '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M3 9l1-5h16l1 5"/><path d="M4 9v11h16V9"/><path d="M9 20v-6h6v6"/></svg>');
          tag.appendChild(document.createTextNode(isGoogle ? label('google') : label('store')));
          card.appendChild(tag);
        }
        item.appendChild(card);
        return item;
      }

      function loadOlder(needed) {
        if (olderDone || !list) return Promise.resolve();
        olderPage++;
        return fetch(olderSource + '&page=' + olderPage)
          .then(function(response) { if (!response.ok) throw new Error(response.status); return response.json(); })
          .then(function(data) {
            var doc = new DOMParser().parseFromString(data.html || '', 'text/html');
            var reviews = doc.querySelectorAll('.jdgm-rev');
            if (!reviews.length) { olderDone = true; return; }
            reviews.forEach(function(rev) {
              var item = buildCard(rev);
              if (item) {
                list.appendChild(item);
                items.push(item);
              }
            });
            // Keep going until there are enough new cards for this filter
            if (matchingCount() < needed && olderPage < 60) return loadOlder(needed);
          })
          .catch(function() { olderDone = true; });
      }

      if (more) more.addEventListener('click', function() {
        shown += perPage;
        if (matchingCount() >= shown || olderDone) {
          render();
          return;
        }
        var original = more.textContent;
        more.setAttribute('aria-busy', 'true');
        more.textContent = label('loading');
        loadOlder(shown).then(function() {
          more.removeAttribute('aria-busy');
          more.textContent = original;
          render();
        });
      });

      render();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-finder"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var DAYS = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

    // "Mo-Th 10:00-19:00, Fr 10:00-21:00" -> { 1: [600, 1140], ... } (minutes)
    function parseHours(text) {
      var week = {};
      (text || '').split(',').forEach(function(part) {
        var match = part.trim().match(/^([A-Z][a-z])(?:-([A-Z][a-z]))?\s+(\d{1,2}):(\d{2})-(\d{1,2}):(\d{2})$/);
        if (!match) return;
        var start = DAYS.indexOf(match[1]);
        var end = match[2] ? DAYS.indexOf(match[2]) : start;
        if (start < 0 || end < 0) return;
        var open = +match[3] * 60 + +match[4];
        var close = +match[5] * 60 + +match[6];
        for (var i = start; ; i = (i + 1) % 7) {
          week[i] = [open, close];
          if (i === end) break;
        }
      });
      return week;
    }

    function formatTime(minutes) {
      var h = Math.floor(minutes / 60);
      var m = minutes % 60;
      var suffix = h >= 12 ? 'pm' : 'am';
      var h12 = h % 12 || 12;
      return h12 + (m ? ':' + String(m).padStart(2, '0') : '') + suffix;
    }

    function nowIn(timeZone) {
      try {
        var parts = new Intl.DateTimeFormat('en-US', { timeZone: timeZone, weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' }).formatToParts(new Date());
        var get = function(type) { return (parts.find(function(p) { return p.type === type; }) || {}).value; };
        var day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(get('weekday'));
        return { day: day, minutes: +get('hour') * 60 + +get('minute') };
      } catch (e) {
        var d = new Date();
        return { day: d.getDay(), minutes: d.getHours() * 60 + d.getMinutes() };
      }
    }

    function dayName(index) {
      return new Intl.DateTimeFormat(undefined, { weekday: 'long' }).format(new Date(2024, 0, 7 + index));
    }

    document.querySelectorAll('[data-store-finder]').forEach(function(finder) {
      var labels = {
        open: finder.getAttribute('data-label-open') || '',
        today: finder.getAttribute('data-label-closed-today') || '',
        later: finder.getAttribute('data-label-closed-later') || '',
        closed: finder.getAttribute('data-label-closed') || ''
      };
      var now = nowIn(finder.getAttribute('data-time-zone') || 'America/Phoenix');
      var stores = Array.prototype.slice.call(finder.querySelectorAll('[data-store]'));
      var map = finder.querySelector('[data-store-map]');

      // Open / closed status from each store's opening hours
      stores.forEach(function(store) {
        var status = store.querySelector('[data-store-status]');
        var week = parseHours(store.getAttribute('data-hours'));
        if (!status || !Object.keys(week).length) return;
        var today = week[now.day];
        var text;
        if (today && now.minutes >= today[0] && now.minutes < today[1]) {
          text = labels.open.replace('[time]', formatTime(today[1]));
          status.classList.add('is-open');
        } else if (today && now.minutes < today[0]) {
          text = labels.today.replace('[time]', formatTime(today[0]));
        } else {
          for (var i = 1; i <= 7; i++) {
            var next = week[(now.day + i) % 7];
            if (next) {
              text = labels.later.replace('[day]', dayName((now.day + i) % 7)).replace('[time]', formatTime(next[0]));
              break;
            }
          }
          text = text || labels.closed;
        }
        status.textContent = text;
        status.hidden = false;
      });

      // Show a store on the map
      function select(store) {
        stores.forEach(function(s) { s.classList.toggle('is-selected', s === store); });
        if (!map) return;
        var query = store.getAttribute('data-map-query');
        map.src = 'https://maps.google.com/maps?q=' + encodeURIComponent(query) + '&z=14&output=embed';
        if (window.matchMedia('(max-width: 1024px)').matches) {
          map.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }

      stores.forEach(function(store) {
        var button = store.querySelector('[data-show-on-map]');
        if (button) button.addEventListener('click', function() { select(store); });
      });

      // City filters
      var chips = Array.prototype.slice.call(finder.querySelectorAll('[data-city-filter]'));
      chips.forEach(function(chip) {
        chip.addEventListener('click', function() {
          var city = chip.getAttribute('data-city-filter');
          chips.forEach(function(c) {
            var active = c === chip;
            c.classList.toggle('is-active', active);
            c.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          var firstVisible = null;
          stores.forEach(function(store) {
            var show = !city || store.getAttribute('data-city') === city;
            store.hidden = !show;
            if (show && !firstVisible) firstVisible = store;
          });
          if (firstVisible && !firstVisible.classList.contains('is-selected') && map) {
            stores.forEach(function(s) { s.classList.toggle('is-selected', s === firstVisible); });
            map.src = 'https://maps.google.com/maps?q=' + encodeURIComponent(firstVisible.getAttribute('data-map-query')) + '&z=14&output=embed';
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
